export { InPlatformLayout } from './in_platform';
export type { InPlatformLayoutProps } from './in_platform';
